import { render } from "./px-label.vue?vue&type=template&id=580241fe&scoped=true&ts=true"
import script from "./px-label.vue?vue&type=script&lang=ts"
export * from "./px-label.vue?vue&type=script&lang=ts"

import "./px-label.vue?vue&type=style&index=0&id=580241fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580241fe"]])

export default __exports__